import { http } from '../helpers/axiosHelper';
class candidateStepService {
   async patch(body: Object[], candidate_step_id: Number) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/candidate-step/' + candidate_step_id, body, {
            params: { include: 'submission' },
         })
         .then((response) => {
            return response.data;
         });
   }
}
export default new candidateStepService();
